import React, { useState, useEffect } from 'react';
import './GoogleReviewPopup.css';

const GoogleReviewPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Check localStorage to respect user dismissal or past views
    const dismissed = localStorage.getItem('reviewPopupDismissed');
    const lastShownDate = localStorage.getItem('reviewPopupLastShown');
    const today = new Date().toDateString();

    // Show only if not permanently dismissed and not shown today
    if (!dismissed && lastShownDate !== today) {
      // 7-second delay gives users time to browse first (non-annoying)
      const timer = setTimeout(() => {
        setOpen(true);
        localStorage.setItem('reviewPopupLastShown', today);
      }, 7000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = (permanent = false) => {
    setOpen(false);
    if (permanent) {
      localStorage.setItem('reviewPopupDismissed', 'true');
    }
  };

  const handleLeaveReview = () => {
    // Replace with your actual Google review link
    window.open('https://www.google.com/search?q=Za420dc&sca_esv=3f47dd1fae4872cf&biw=1280&bih=561&sxsrf=APpeQnufXRycxaLnJGevpBWT7Gx44qwQWg%3A1790554417532&ei=MbG5ar-HIMTm5NoPgZLh4A0&ved=2ahUKEwj_44eA_4-XAxVEM1kFHQFJGNwQ4dUDegQIBhAN&uact=5&oq=Za420dc&gs_lp=Egxnd3Mtd2l6LXNlcnAiB1phNDIwZGMyAhAmMgUQABjvBTIFEAAY7wUyCBAAGIAEGKIEMgUQABjvBUj7GFChD1ihD3ADeAGQAQCYAWmgAWmqAQMwLjG4AQPIAQD4AQL4AQGYAgGgAnCYAwCIBgGSBwMwLjGgB5kCsgcDMC4xuAdwwgcDMi0xyAcEgAgB&sclient=gws-wiz-serp', '_blank');
    setOpen(false);
    localStorage.setItem('reviewPopupDismissed', 'true');
  };

  if (!open) return null;

  return (
    <div className="review-popup-overlay">
      <div className="review-popup-card">
        {/* Close Button */}
        <button 
          onClick={() => handleClose(true)} 
          className="review-popup-close"
          aria-label="Close review prompt"
        >
          &times;
        </button>

        {/* Compact Header */}
        <div className="review-popup-header">
          <span className="review-popup-icon">🎁</span>
          <div>
            <h3>Get a free gummy or two pre-rolls!</h3>
            <p>Just leave us a quick Google review!</p>
          </div>
        </div>

        {/* Body Content */}
        <div className="review-popup-body">
          <div className="review-stars">
            {'★★★★★'}
            <span>Love our service?</span>
          </div>

          <p className="review-instructions">
            Review us on Google, screenshot it, and text it to{' '}
            <strong>202-873-3183</strong> to claim your free gift!
          </p>

          {/* Action Buttons */}
          <div className="review-popup-actions">
            <button 
              onClick={handleLeaveReview} 
              className="review-btn review-btn-primary"
            >
              ⭐ Review Now
            </button>
            <button 
              onClick={() => handleClose(false)} 
              className="review-btn review-btn-outline"
            >
              Later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoogleReviewPopup;